import { Stack, Typography } from "@mui/material";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import type { SmartViewArtifact } from "../../../../../api/types/smartViewArtifactsTypes";
import ArtifactPreviewImage from "../previews/ArtifactPreviewImage";

const getVersionLabel = ({ publishedVersion, latestVersion }: SmartViewArtifact): string => {
  if (publishedVersion) {
    return `Published · v${publishedVersion}`;
  }
  return latestVersion > 0 ? `Draft · version ${latestVersion}` : "Draft";
};

const getCaption = (artifact: SmartViewArtifact, canManage: boolean): string => {
  const date = convertISODateTime(artifact.modifiedAt ?? artifact.createdAt);
  return canManage ? `${getVersionLabel(artifact)} · ${date}` : `Updated ${date}`;
};

interface Props {
  artifact: SmartViewArtifact;
  canManage: boolean;
}

const ArtifactPreviewCard = ({ artifact, canManage }: Props) => (
  <Stack spacing={1.25}>
    <ArtifactPreviewImage artifact={artifact} sx={{ border: 1, borderColor: "divider", borderRadius: 1.5 }} />
    <Stack spacing={0.25} sx={{ px: 0.5 }}>
      <Typography variant="subtitle2">{artifact.name}</Typography>
      <Typography variant="caption" color="textSecondary">
        {getCaption(artifact, canManage)}
      </Typography>
    </Stack>
  </Stack>
);

export default ArtifactPreviewCard;
